import { createFileRoute } from '@tanstack/react-router';
import { OfferSetupPage } from '@/features/new-client-offer';

export const Route = createFileRoute('/_auth/$orgId/marketing/new-client-offer/setup')({
  component: SetupRoute,
});

function SetupRoute() {
  const { orgId } = Route.useParams();
  return <OfferSetupPage routeOrgId={orgId} />;
}
